import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserStockModel } from './userStock.model';
import {
  MatSnackBar,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserStockService } from './userStock.service';
import { GetUserInfo } from '../../../shared/utils';
import { DummyComponent } from '../../../shared/dummy.component';

@Component({
    selector: 'convfact-userStock',
    templateUrl: './userStock.component.html',
    styleUrls: [],
    standalone: false
})
export class UserStockComponent implements OnInit {
  userStock = new UserStockModel();
  errors: Record<string, unknown> = {};

  private readonly userStockService = inject(UserStockService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  public readonly snackBar = inject(MatSnackBar);
  public readonly dummy = inject(DummyComponent);
  private readonly destroyRef = inject(DestroyRef);

  submit(): void {}

  displayInfo(text: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    this.snackBar.open(text, '', options);
  }

  async saveData(uStock: UserStockModel): Promise<void> {
    try {
      this.userStock = await this.userStockService.editData(uStock);
      this.displayInfo('Información guardada correctamente');
      this.dummy.redirectTo(this.router.url);
    } catch (errors: any) {
      this.errors = JSON.parse(errors['error'])['data'];
    }
  }

  ngOnInit(): void {
    if (GetUserInfo.haveStock) {
      this.route.params
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(async () => {
          this.userStock = await this.userStockService.loadData();
        });
    } else {
      this.displayInfo('Actualmente no dispone de acceso a este modulo.');
      this.router.navigate(['/resume']);
    }
  }

  returnToIndex(): void {
    this.router.navigate(['/account']);
  }
}